import Swal from 'sweetalert2/dist/sweetalert2'

const generateNoty = defaults => overrides => {
  overrides = typeof overrides === 'string' ? { text: overrides } : overrides
  return Swal.fire({
    ...defaults,
    ...overrides
  })
}

export const Notifications = {
  success: generateNoty({ type: 'success' }),
  error: generateNoty({ type: 'error' }),
  warning: generateNoty({ type: 'warning' }),
  info: generateNoty({ type: 'info' }),
  question: generateNoty({ type: 'question' }),
  fire (params) {
    return Swal.fire(params)
  },
  Swal
}
